<script setup lang="ts">
import type {Component} from 'vue'
import {computed} from 'vue'
import {PropertyValueType} from '@toolify/server/src/services/DatabasePropertyService/types/PropertyValueType'
import {
  DatabasePropertyValueEditStrategyByTypeMap,
} from '@toolify/client/src/modules/databases/maps/DatabasePropertyValueEditStrategyByTypeMap'
import {
  DatabasePropertyValueStrategyByTypeMap,
} from '@toolify/client/src/modules/databases/maps/DatabasePropertyValueReadStrategyByTypeMap'

interface Props {
  valueType: PropertyValueType | null
  listeners?: unknown
  valuePayload: unknown
  relativeToDate?: Date
  cellPayload?: unknown
  isFocused: boolean
  isInEditMode: boolean
  isCellHidden?: boolean
  isInPreviewMode?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  listeners: null,
  relativeToDate: null,
  cellPayload: null,
  isCellHidden: false,
  valueType: null,
})


const strategyComponent = computed<Component>(() => {
  if (DatabasePropertyValueEditStrategyByTypeMap.has(props.valueType) && (props.isInEditMode || props.isInPreviewMode)) {
    return DatabasePropertyValueEditStrategyByTypeMap.get(props.valueType)
  }
  return DatabasePropertyValueStrategyByTypeMap.get(props.valueType)
})

const optionalStrategyProps = computed(() => ({
  ...(props.isCellHidden ? {isCellHidden: true} : {}),
  ...(props.isInPreviewMode ? {isInPreviewMode: true} : {}),
}))
</script>

<template>
  <Component
    :is="strategyComponent"
    :payload="props.valuePayload"
    :relativeToDate="props.relativeToDate"
    :cellPayload="props.cellPayload || {}"
    :isFocused="props.isFocused"
    :isInEditMode="props.isInEditMode"
    v-bind="optionalStrategyProps"
    v-on="props.listeners || {}"
  />
</template>

